import { render } from "./ConditionOr.vue?vue&type=template&id=70e2a1ae&scoped=true"
import script from "./ConditionOr.vue?vue&type=script&lang=ts"
export * from "./ConditionOr.vue?vue&type=script&lang=ts"

import "./ConditionOr.vue?vue&type=style&index=0&id=70e2a1ae&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-70e2a1ae"

export default script
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QBtn});
